var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item pl-3"},[(_vm.googleAnalytics4Exists)?_c('a',{staticClass:"nav-link",attrs:{"id":"googleAnalytics4Link","href":_vm.linkGoogleAnalytics4}},[_vm._v("\n    Google Analytics - GA4 - BETA\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }